import React from "react";
import { Channel } from "stream-chat";
import { MessageInputFlat } from "stream-chat-react";

export const KMessageInput = ({ channel, ...rest }: { channel: Channel }) => {
  return <MessageInputFlat {...rest} />;
};
